import { computed } from "vue";
import { useFeatureFlags } from "@/composables/use-feature-flags";

export const CHAT_THIRD_PARTY_CONTEST_URL_PREFIXES_FLAG =
  "chat_third_party_contest_url_prefixes";

export function normalizeChatContestUrlPrefix(value: unknown): string | null {
  if (typeof value !== "string") return null;

  try {
    const url = new URL(value);
    if (url.protocol !== "https:") return null;

    return url.href;
  } catch (_error) {
    return null;
  }
}

export function normalizeChatContestLinkHref(value: string): string | null {
  try {
    const url = new URL(value);
    if (url.protocol !== "https:") return null;

    return url.href;
  } catch (_error) {
    return null;
  }
}

export function findChatContestLinkHref(
  href: string,
  configuredPrefixes: readonly unknown[],
): string | null {
  const normalizedHref = normalizeChatContestLinkHref(href);
  if (!normalizedHref) return null;

  for (const value of configuredPrefixes) {
    const normalizedPrefix = normalizeChatContestUrlPrefix(value);
    if (normalizedPrefix && normalizedHref.startsWith(normalizedPrefix)) {
      return normalizedHref;
    }
  }

  return null;
}

export function useChatContestLinkConfig() {
  const { getJSON, loaded } = useFeatureFlags();
  const configuredPrefixes = getJSON<unknown[]>(
    CHAT_THIRD_PARTY_CONTEST_URL_PREFIXES_FLAG,
    [],
  );

  const contestPrefixes = computed(() =>
    Array.isArray(configuredPrefixes.value) ? configuredPrefixes.value : [],
  );

  function getContestLinkHref(href: string): string | null {
    return findChatContestLinkHref(href, contestPrefixes.value);
  }

  return {
    loaded,
    contestPrefixes,
    getContestLinkHref,
  };
}
